import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";

import * as endpoints from "./endpoints";
import {
  myProfile,
  myProfileFailed,
  myProfileSuccess,
  updateUserProfile,
  updateUserProfileFailed,
  updateUserProfileSuccess,
} from "./slice";

//--------------------myProfileSaga-------------------------

function* myProfileSaga(action: ReturnType<typeof myProfile>): any {
  try {
    const response = yield call(request.get, `${endpoints.myProfile}`);
    yield put(myProfileSuccess(response.data));
  } catch (error: any) {
    yield put(myProfileFailed(error));
  }
}
//--------------------updateUserProfileDataSaga-------------------------

function* updateUserProfileDataSagas(
  action: ReturnType<typeof updateUserProfile>,
): any {
  try {
    const {
      id,
      firstName,
      lastName,
      phone,
      email,
      state,
      city,
      zipCode,
      profileImage,
    } = action.payload;

    const formData = new FormData();
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("phone", phone);
    formData.append("email", email);
    formData.append("state", state);
    formData.append("city", city);
    formData.append("zipCode", zipCode);

    if (profileImage) {
      formData.append("profileImage", profileImage);
    }

    const response = yield call(
      request.put,
      `${endpoints.updateUserProfile}/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    yield put(updateUserProfileSuccess(response.data));
    yield put(myProfileSuccess(response.data));
  } catch (error: any) {
    yield put(updateUserProfileFailed(error));
  }
}

function* myProfileSagas() {
  yield all([takeLatest(myProfile, myProfileSaga)]);
  yield all([takeLatest(updateUserProfile, updateUserProfileDataSagas)]);
}

export { myProfileSagas };
